import ProcessedBooking from "../../stores/domainStore/pages/models/processedBooking";
import {TransactionsColumnNames} from "../../shared/enums/transactionsColumnNames";
import {SortOrder} from "../../shared/enums/sortOrder";
import {compareDates, compareNumbers, compareStrings} from "./sortUtil";

export class ProcessedBookingsSortUtil {
  transactions: ProcessedBooking[];
  sortField: TransactionsColumnNames;
  sortOrder: SortOrder;

  constructor(
    transactions: ProcessedBooking[],
    sortField: TransactionsColumnNames,
    sortOrder: SortOrder
  ) {
    this.transactions = transactions;
    this.sortField = sortField;
    this.sortOrder = sortOrder;
  }

  sort(): ProcessedBooking[] {
    return Array.from(this.transactions).sort(
      (a: ProcessedBooking, b: ProcessedBooking) => {
        switch (this.sortField) {
          case TransactionsColumnNames.DateCharged: {
            const diff = compareDates(
              a.createdDate,
              b.createdDate,
              this.sortOrder
            );
            // Secondary sort on payee
            return diff === 0
              ? compareStrings(a.payeeName, b.payeeName, this.sortOrder)
              : diff;
          }
          case TransactionsColumnNames.Cost: {
            const aVal = a.price;
            const bVal = b.price;
            const diff = compareNumbers(aVal, bVal, this.sortOrder);
            // Secondary sort on charged date
            return diff === 0
              ? compareDates(a.timestamp, b.timestamp, this.sortOrder)
              : diff;
          }
        }

        const aVal = this.getProperty(a, this.sortField);
        const bVal = this.getProperty(b, this.sortField);

        const diff = compareStrings(aVal, bVal, this.sortOrder);
        // Secondary sort on charged date
        return diff === 0
          ? compareDates(a.timestamp, b.timestamp, this.sortOrder)
          : diff;
      }
    );
  }

  private getProperty(
    transaction: ProcessedBooking,
    columnName: TransactionsColumnNames
  ): string | undefined {
    switch (columnName) {
      case TransactionsColumnNames.Event:
        return transaction.eventTitle;
      case TransactionsColumnNames.ChargedTo:
        return transaction.payeeName;
      case TransactionsColumnNames.Description:
        return transaction.transactionDetails;
      case TransactionsColumnNames.Status:
        return transaction.isSuccess ? "1" : "2";
    }
    return "";
  }
}
